// src/components/Forms/CourseOrderForm/BumpOffer.jsx
import React from "react";

function getEffectivePrice(offer) {
  if (offer?.price_type === "free") return 0;
  const raw = offer?.discounted_price ?? offer?.amount ?? offer?.price ?? "0";
  return Number.parseFloat(String(raw).trim()) || 0;
}

function hasDiscount(offer) {
  if (offer?.price_type === "free") return false;
  const base = Number.parseFloat(String(offer?.amount ?? offer?.price ?? "0").trim()) || 0;
  const eff = getEffectivePrice(offer);
  return eff > 0 && base > 0 && eff < base;
}

export default function BumpOffer({ bumpOffer, isSelected, onToggle }) {
  if (!bumpOffer) return null;

  const effPrice = getEffectivePrice(bumpOffer);
  const basePrice = Number.parseFloat(String(bumpOffer.price || "0").trim()) || 0;
  const discounted = hasDiscount(bumpOffer);

  return (
    <div className="osof-offer-box mt-3" id={`bump-box-${bumpOffer.id}`}>
      <div className="d-flex align-items-start gap-2">
        <input
          type="checkbox"
          className="form-check-input mt-1"
          id={`bump-checkbox-${bumpOffer.id}`}
          checked={isSelected}
          onChange={() => onToggle(bumpOffer.id)}
          style={{ cursor: "pointer", width: 19, height: 19 }}
        />
        <div className="flex-grow-1">
          <label
            htmlFor={`bump-checkbox-${bumpOffer.id}`}
            className="fw-bold mb-1 d-block text-dark"
            style={{ cursor: "pointer", fontSize: "14.5px" }}
          >
            {bumpOffer.title}
          </label>
          <div className="mb-1" style={{ fontSize: "13px" }}>
            <span className="fw-bold text-danger">
              ONLY ${effPrice.toFixed(2)} ONE TIME SPECIAL
            </span>
            {discounted && (
              <span className="osof-old-price ms-2">${basePrice.toFixed(2)}</span>
            )}
          </div>
          {bumpOffer.description && (
            <p className="mb-0 text-muted" style={{ fontSize: "12.5px", lineHeight: "1.4" }}>
              {bumpOffer.description}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
